module.exports = __webpack_public_path__ + "img/kommune-1037.bb757650.svg";